
import { useForm } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "../actions";
import Steps from "../../Components/Steps";
import FormNavigation from "../FormNavigation";
import Input from "../../Components/Input";
import RadioGroup from "../../Components/tw/RadioGroup";
import { SEATING_CAPACITY, COOKING_ON_PREMISES, ADDITIONAL_FITOUT_OR_PLUMBING_WORK } from "../../Constants";
import KitchenFixtures from "./KitchenFixtures";
import ErrorMessage from "../../Components/ErrorMessage/index"
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { useTradeWasteContext } from "../tradeWasteContext";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Step3 = () => {
  const [context] = useTradeWasteContext();
  const { actions, state } = useStateMachine({ updateAction });
  const navigate = useNavigate()
  const { control, register, unregister, handleSubmit, watch, formState: { errors } } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
    defaultValues: state?.data
  });
  const additional_work = watch(ADDITIONAL_FITOUT_OR_PLUMBING_WORK, state?.data[ADDITIONAL_FITOUT_OR_PLUMBING_WORK])
  const [uploadError, setUploadError] = useState("")

  const onSubmit = (data: any) => {
    if (additional_work === "Yes" && !context?.plumbingPlans?.length) {
      setUploadError(!context?.menus?.length ? "Please attach supporting documents" : "Please attach a plumbing plan")
    } else if (context?.menus?.length) {
      setUploadError("")
      actions.updateAction(data);
      navigate("/step4");
    } else {
      setUploadError("Please attach your menu")
    }
  };
  const onBack = () => {
    navigate("/step2");
  };
  useEffect(() => { window.scrollTo(0, 0) }, [])
  return (
    <motion.div
      data-testid="step3"
      key="step3"
      initial="initial"
      animate="in"
      exit="out"
      variants={{
        initial: {
          opacity: 0,
        },
        in: {
          opacity: 1,
        },
        out: {
          opacity: 0,
        },
      }}
    >
      <Steps step={3} max={5} />
      <AnimatePresence>
        {!!Object.keys(errors)?.length && (<ErrorMessage isMultiple={Object.keys(errors)?.length > 1} />)}
      </AnimatePresence>
      <form onSubmit={handleSubmit(onSubmit)}>
        <section>
          <h2>Process Details</h2>
          <Input
            defaultValue={state?.data[SEATING_CAPACITY]}
            name={SEATING_CAPACITY}
            id={SEATING_CAPACITY}
            label="What will be the seating capacity of your business (including alfresco)? "
            type="number"
            short={true}
            register={register}
            registerOptions={{
              required: "Please enter seating capacity"
            }}
            errorMessage={errors[SEATING_CAPACITY]?.message as string}
          />
          <RadioGroup
            name={COOKING_ON_PREMISES}
            legend="Will you be cooking food on the premises? "
            errorMessage={errors[COOKING_ON_PREMISES]?.message as string}
            registerOptions={{
              required: "Please make a selection"
            }}
            register={register}
            unregister={unregister}
            radios={[
              { value: "Yes" },
              { value: "No" },
            ]}
          />
        </section>
        {/* kitchen fixtures */}
        <KitchenFixtures control={control} register={register} unregister={unregister} watch={watch} errors={errors} uploadError={uploadError} />
        {(Object.keys(errors)?.length || uploadError) && (<ErrorMessage isMultiple={(Object.keys(errors)?.length ?? 0) + (uploadError ? 1 : 0) > 1} isBottom={true} />)}
        <FormNavigation isLast={false} handleBack={onBack} />
      </form >
    </motion.div>
  );
};

export default Step3;
